// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon6(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M15.233 21.087a.334.334 0 1 0-.47.474l1.81 1.81a.334.334 0 1 0 .47-.474l-1.81-1.81ZM11.797 14.586a1.193 1.193 0 1 0 .02 2.387 1.193 1.193 0 0 0-.02-2.387Zm0 1.72a.527.527 0 1 1 .02-1.053.527.527 0 0 1-.02 1.053ZM21.62 15.95a1.08 1.08 0 1 0-.006 2.16 1.08 1.08 0 0 0 .006-2.16Zm0 1.49a.413.413 0 1 1-.006-.827.413.413 0 0 1 .006.826ZM16 12.746a1.363 1.363 0 1 0 0-2.727 1.363 1.363 0 0 0 0 2.727Zm0-2.056a.696.696 0 1 1 0 1.392.696.696 0 0 1 0-1.393ZM21.25 21.834h-.153a.333.333 0 1 0 0 .667h.153a.333.333 0 0 0 0-.667ZM17.876 14.784h.234a.333.333 0 0 0 0-.667h-.234a.333.333 0 1 0 0 .667ZM12.48 18.527h-.123a.333.333 0 0 0 0 .667h.123a.333.333 0 1 0 0-.667ZM15.486 17.087a.333.333 0 0 0 0 .47l.113.11a.334.334 0 0 0 .47-.47l-.11-.11a.332.332 0 0 0-.473 0ZM10.933 13.696a.334.334 0 0 0 0-.667h-.156a.333.333 0 1 0 0 .667h.156Z" />
        <path d="M27.81.367A.334.334 0 0 0 27.475 0H4.523a.333.333 0 0 0-.334.367l2.864 27.776v3.61a.333.333 0 0 0 .333.334h17.227a.333.333 0 0 0 .333-.334V28.15L27.809.367Zm-2.527.3-.5 4.833c-5.9.98-5.804 1.137-10.06.5-3.187-.48-5.274.12-7.394.63L6.716.667h18.566ZM7.398 7.297c2.267-.547 4.157-1.104 7.224-.63 4.293.646 4.233.506 10.09-.467L22.665 26H9.332L7.4 7.297ZM6.046.667c5.667 55-3.127-30.36 2.643 25.686a.334.334 0 0 0 .334.3h13.953a.333.333 0 0 0 .333-.3L25.952.667h1.154L24.312 27.8H7.686L4.893.667h1.153ZM24.279 31.42H7.72v-2.953h16.56v2.953Z" />
        <path d="M15.904 19.363a2.867 2.867 0 1 0 0 5.734 2.867 2.867 0 0 0 0-5.734Zm0 5.064a2.2 2.2 0 1 1 0-4.4 2.2 2.2 0 0 1 0 4.4Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon6;
